import { createContext, useContext, useState, useCallback } from 'react'

type ExportFormat = 'csv' | 'png' | 'jpg' | 'pdf'

export interface HighchartsExportAction {
    format: ExportFormat
    downloadHandler: () => void
}

interface HighchartsExportContextType {
    actions: HighchartsExportAction[]
    register: (actions: HighchartsExportAction[]) => void
}

const HighchartsExportContext = createContext<HighchartsExportContextType | null>(null)

export const HighchartsExportProvider = ({ children }: { children: React.ReactNode }) => {
    const [actions, setActions] = useState<HighchartsExportAction[]>([])

    const register = useCallback((newActions: HighchartsExportAction[]) => {
        setActions(newActions)
    }, [])

    return <HighchartsExportContext.Provider value={{ actions, register }}>{children}</HighchartsExportContext.Provider>
}

export const useHighchartsExport = (): HighchartsExportContextType => {
    const context = useContext(HighchartsExportContext)
    if (!context) {
        throw new Error('useHighchartsExport must be used within a HighchartsExportProvider')
    }
    return context
}
